import React, {Fragment} from 'react'
import Loader from './Loader'

class TransactionHistoryLoader extends React.Component{

    render(){
      return(
        <tr>
          <td className="pl-41 text"><Loader width="250" height="15" /></td>
            <td className="text"><Loader width="250" height="15" /></td>
              <td><span className="transaction-status" id={this.props.btnId}><Loader width="250" height="15" /></span></td>
              <td className="text-thin"><Loader width="250" height="15" /></td>
            <td className="p-28-0">
            <Loader width="150" height="15" />
          </td>
      </tr>
      )
    }
  }

  export default TransactionHistoryLoader
  